module.exports = __webpack_public_path__ + "static/media/open-sans-v17-latin_cyrillic-regular.abb625c8.woff";